import { StateCreator } from "zustand";

export interface AuthSlice {
  memberId: number | null;
  setMemberId: (id: number | null) => void;
  accessToken: string | null;
  setAccessToken: (token: string | null) => void;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
}

export const createAuthSlice: StateCreator<AuthSlice> = (set) => ({
  memberId: null,
  setMemberId: (id) =>
    set(() => ({
      memberId: id,
      isLoading: id === null ? true : false, // Set loading true if id is null, false if valid id
    })),
  accessToken: null,
  setAccessToken: (token) =>
    set((state) => ({
      accessToken: token,
      isLoading: state.memberId ? false : true, // Keep loading if memberId is still null
    })),
  isLoading: true,
  setIsLoading: (loading) => set({ isLoading: loading }),
});
